import type { UseQueryOptions } from '@tanstack/vue-query'
import {
  keepPreviousData,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from '../query-ids'
import { getRecentElementalItems } from '~~/src/api/users'
import type { GetReturn } from '~~/src/types/utils'

export const useRecentElementalQuery = (
  args: {
    userId: MaybeRef<string | undefined | null>
    size?: number
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getRecentElementalItems>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
) => {
  return useQuery({
    queryKey: [TanStackQueryIds.RECENT_ELEMENTAL, args.userId, args.size],
    queryFn: async ({ queryKey }) => {
      const [_, userId, size] = queryKey
      const data = await getRecentElementalItems(userId as string, size as number)
      return data
    },
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    enabled: !!args.userId,
    ...options,
  })
}
